export function sortObjectsByProperty(method, arr, foldersFirst) {
    // Boolean sorting not functional
    return arr.slice().sort((a, b) => {
        if (foldersFirst) {
            if (a.isDir && !b.isDir) return -1;
            if (!a.isDir && b.isDir) return 1;
        }
        let comparison = null
        if (method.property == 'transcribed') {
            comparison = a[method.property] == true - b[method.property] == true// || b[method.property] == undefined ? 1 : a[method.property] == false && b[method.property] == true || a[method.property] == undefined ? -1 : 0;
            return -comparison
        } else {
            comparison = a[method.property] > b[method.property] ? 1 : a[method.property] < b[method.property] ? -1 : 0;
            return method.inverse ? -comparison : comparison;
        }
    });
}

export default sortObjectsByProperty